import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "context/languageContext";
import { getSpacesByFilters } from "services/spaceList.services";
import { getQueryParamsFromFilters } from "helpers/searchParams";
import {getOtherFilterOptions} from "services/filters.services";
import { ErrorMessage, Filters, SpacesList } from "views/SpacesListPage/components";

import styles from "./styles.module.scss";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [shownSpaces, setShownSpaces] = useState([]);
  const { language } = useLanguage();
  const [t] = useTranslation("global");
  const [moreFilterOptions, setMoreFilterOptions] = useState({});

  const filters = useSelector((state) => state.filters);
  const prevFiltersRef = useRef(filters);

  useEffect(() => {
    const fetchSpaces = async () => {
        setLoading(true);
        setError(null);

        try {const response = await getSpacesByFilters({
            type: "last_minute",
            page: 1,
            perPage: 16,
            lang: language,
          });
  
          setShownSpaces(response.data);
        }catch (err) {
            setError(err.message);
          } finally {
            setLoading(false);
          }
    };
    const fetchFilterOptions = async () => {
      try {
        const options = await getOtherFilterOptions({...filters, lang: language,});
        setMoreFilterOptions(options);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSpaces();
    fetchFilterOptions();

    if (JSON.stringify(filters) !== JSON.stringify(prevFiltersRef.current)) {
      const queryParams = getQueryParamsFromFilters(filters);
      navigate(`/search?${queryParams}`);
    }

    prevFiltersRef.current = filters;
  }, [filters, language]);

  return (
    <section className={styles.notFoundPage}>
      <Filters moreFilterOptions={moreFilterOptions}/>
      <div className={`${styles.bodyWrapper} pageContainer`}>
        <ErrorMessage />
        <SpacesList
          loading={loading}
          spaces={shownSpaces}
          error={error}
          pagination = {{per_page: 10}}
        />
      </div>
    </section>
  );
};

export default NotFoundPage;
